import React from 'react';
import { Card, Table, Typography, message } from 'antd';
import dayjs from 'dayjs';
import { APP_LOCAL_DATE_FORMAT } from 'config/constants';
import { formatDateString } from '../../../utils';
import { listInspectorProfessionsMe } from '../../inspector-professions/services/inspector-professionService';

const DEFAULT_SORT = 'registrationDate,desc';

const InspectorProfessionsPage: React.FC = () => {
  const [data, setData] = React.useState<any[]>([]);
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const [total, setTotal] = React.useState(0);
  const [loading, setLoading] = React.useState(false);

  const fetchData = React.useCallback(async () => {
    setLoading(true);
    try {
      const response = await listInspectorProfessionsMe(page - 1, pageSize, DEFAULT_SORT);
      setData(Array.isArray(response?.content) ? response.content : []);
      setTotal(Number(response?.totalElements) || 0);
    } catch (error) {
      console.error('InspectorProfessionsPage fetch failed', error);
      message.error('Meslek bilgileriniz alınamadı.');
      setData([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [page, pageSize]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = [
    {
      title: 'Meslek',
      dataIndex: ['profession', 'name'],
      render: (_: any, record: any) => record?.profession?.name ?? '-',
    },
    { title: 'Kayıt Numarası', dataIndex: 'registrationNumber' },
    {
      title: 'Kayıt Tarihi',
      dataIndex: 'registrationDate',
      render: (value: string) => (value ? formatDateString(value) : ''),
    },
    { title: 'Diploma No', dataIndex: 'diplomaNumber' },
    {
      title: 'Mezuniyet Tarihi',
      dataIndex: 'graduationDate',
      render: (value: string) => (value ? dayjs(value).format(APP_LOCAL_DATE_FORMAT) : ''),
    },
  ];

  return (
    <Card
      className='br-30px'
      title={<Typography.Title level={4} style={{ margin: 0 }}>Mesleklerim</Typography.Title>}
    >
      <Table
        rowKey={(record: any) => record?.id ?? `${record?.registrationNumber}-${record?.profession?.id}`}
        dataSource={data}
        columns={columns as any}
        loading={loading}
        pagination={{
          current: page,
          pageSize,
          total,
          onChange: (nextPage, nextSize) => {
            setPage(nextPage);
            setPageSize(nextSize || 10);
          },
        }}
      />
    </Card>
  );
};

export default InspectorProfessionsPage;
